import { BookingGateWayModeIdEnum, dayjsFormatLongOrdinal } from '@alluradirect/react';
import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import { formatCanadianCurrency } from 'helpers/currencyHelpers';
import { CheckoutStepProps } from 'pages/[propertyId]/reservenow';
import { useMemo } from 'react';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import { LoadingButton } from 'components/core/LoadingButton/LoadingButton';
// import { useGuestBookingReceipt } from 'components/views/pages/Checkout/hooks/useGuestBookingReceipt';

export const CheckoutReservationConfirmed = ({
  bookingData,
  userData,
}: Pick<CheckoutStepProps, 'bookingData' | 'userData'>) => {
  const isLoading = !bookingData;

  const isGatewayClosed = bookingData?.PROPERTY.GATEWAY_MODE.ID === BookingGateWayModeIdEnum.closed;

  const guestEmail = userData?.EMAIL ?? '--';
  const amountPaid = bookingData ? formatCanadianCurrency(bookingData.PAYMENT.PAID_TO_DATE) : '--';

  const hasNextPayment =
    bookingData && Object.keys(bookingData?.PAYMENT?.NEXT_PAYMENT).length > 0
      ? bookingData.PAYMENT.NEXT_PAYMENT.TOTAL !== '0.00'
      : false;
  const nextPaymentDate = bookingData ? dayjsFormatLongOrdinal(bookingData.PAYMENT.NEXT_PAYMENT.DUE_DATE) : '--';
  const nextPaymentAmount = bookingData ? formatCanadianCurrency(bookingData.PAYMENT.NEXT_PAYMENT.TOTAL) : '--';

  // TODO: receipt functionality backlogged for now
  // const guestBookingReceipt = useGuestBookingReceipt({
  //   bookingId: Number(booking?.ID) ?? 0,
  //   userId: Number(userId) ?? 0,
  // });

  const sectionTitle = useMemo(() => {
    if (isGatewayClosed) {
      return 'Reservation Request Sent';
    }
    return 'Reservation Confirmed';
  }, [isGatewayClosed]);

  const sectionDescription = useMemo(() => {
    if (isGatewayClosed) {
      return (
        <>
          Thank you for booking, the property host has received your reservation request.
          <br />
          <br />
          Once approved, you will receive an email with a secure payment link for <strong>
            {nextPaymentAmount}
          </strong>{' '}
          CAD.
        </>
      );
    }

    return (
      <>
        Thank you for booking, your credit card has been charged <strong>{amountPaid}</strong> CAD
      </>
    );
  }, [amountPaid, isGatewayClosed, nextPaymentAmount]);

  return (
    <Grid item xs={12}>
      <LoadingSkeleton isLoading={isLoading}>
        <CheckoutSectionTitle>{sectionTitle}</CheckoutSectionTitle>
      </LoadingSkeleton>
      <LoadingSkeleton isLoading={isLoading}>
        <Typography mb={1} variant="body1">
          {sectionDescription}
        </Typography>
      </LoadingSkeleton>
      {hasNextPayment && !isGatewayClosed ? (
        <LoadingSkeleton isLoading={isLoading}>
          <Typography variant="body1" mb={1}>
            The remaining amount of <strong>{nextPaymentAmount}</strong> CAD is required to be paid by{' '}
            <strong>{nextPaymentDate}</strong>.
          </Typography>
        </LoadingSkeleton>
      ) : null}
      {!isGatewayClosed ? (
        <LoadingSkeleton isLoading={isLoading}>
          <Typography variant="body1">
            The payment receipt has been emailed to <strong>{guestEmail}</strong>
          </Typography>
        </LoadingSkeleton>
      ) : null}

      {/* <LoadingButton
        isDisabled={isLoading || !guestBookingReceipt.data}
        size="small"
        variant="text"
        startIcon={<PictureAsPdfIcon />}
        onClick={onClickDownloadReceipt}
      >
        Download the receipt
      </LoadingButton> */}
    </Grid>
  );
};
